import { c as _c } from "react/compiler-runtime";
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import type { MedianIncomeYear } from '../constants';
import { MEDIAN_INCOME_BY_YEAR } from '../constants';
interface RecommendedContentsProps {
  year: MedianIncomeYear;
}

/**
 * ⑧ 추천 콘텐츠 카드 — 가로형 (좌: 제목·요약, 우: 정사각형 썸네일).
 * 카드 전체가 CustomLink — 클릭 시 정책 활용 가이드 상세로 이동.
 */
export const RecommendedContents = t0 => {
  const $ = _c(5);
  const {
    year
  } = t0;
  const {
    recommendedContents
  } = MEDIAN_INCOME_BY_YEAR[year];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-baseline justify-between mobile-tablet:px-16"><h2 className="font-700 text-Gray-900 typo-h5 mobile-tablet:typo-h6">추천 콘텐츠</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== recommendedContents) {
    t2 = recommendedContents.map(_temp);
    $[1] = recommendedContents;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <section className="flex flex-col gap-12">{t1}<div className="flex flex-col gap-12 mobile-tablet:px-16">{t2}</div></section>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(content) {
  return <CustomLink key={content.url} href={content.url} className="flex items-stretch gap-16 rounded-medium border-1 border-Gray-100 bg-Gray-white p-16 transition-colors hover:border-B-300"><div className="line-clamp-2 min-w-0 flex-1 font-700 text-Gray-900 typo-body3">{content.title}</div><div className="relative size-96 shrink-0 overflow-hidden rounded-small bg-Gray-100">{content.thumbnail ? <Image src={content.thumbnail} alt={content.title} fill={true} className="object-cover" /> : null}</div></CustomLink>;
}